import {Params} from '@angular/router';

export class CommandAction {
    url: string;
    queryParams: Params;
    iconName: string;
    withInApp: boolean;

    constructor(url: string,
                queryParams?: Params,
                iconName?: string,
                withInApp?: boolean) {
        this.url = url;
        this.queryParams = queryParams;
        this.iconName = iconName;
        this.withInApp = withInApp;
    }
}
